import React, { useState, useRef, useEffect } from "react";
import {
  Container,
  TextField,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Grid,
  Button,
  Divider,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Autocomplete,
  IconButton,
  Box,
  ListSubheader,
  InputLabel,
  FormControl,
  Select,
  FormHelperText,
} from "@mui/material";
import SignatureCanvas from 'react-signature-canvas';
import axios from 'axios';
import { useParams, useNavigate } from "react-router-dom";
import ShareIcon from '@mui/icons-material/Share';
import LocalHospital from '@mui/icons-material/LocalHospital';
import { API_BASE_URL } from '../../lib/constants';
import theme from '../../theme/theme';
import { ThemeProvider } from '@mui/material/styles';
import { useNotification } from '../../contexts/NotificationContext';
import DraftSaveButton from '../../components/DraftSaveButton';
import { DRAFT_KEYS, loadDraft, hasDraft } from '../../utils/draftUtils';
const checklistItems = [
  {
    name: [
      "Consent / High risk consent",
      "Preparation of parts",
      "Surgical site Marked",
      "Jewels to be removed by the attender",
      "Hearing aid / Prosthesis / Denture / Contact Lens to be removed & given to attender",
      "Starvation from",
      "Bowel Preparation",
      "Investigation: X-Ray, ECG, CT Scan, Lab etc.",
      "Premedication",
      "Blood requirements: WB/PC/FFP/CP/Platslets",
      "Blood requirements units",
      "OT Dress, Cap, Leggings, Nail Polish removed",
      "Allergies",
      "Specify",
      "IV Fluids, Drugs, Disposables, Draw Sheet, Macintosh",
      "OT Drugs & Patient File handed over to OT Nurse",
      "Inj. TT / Test Dose / Antibiotics",
      "Case-Sheet / Investigations / Drugs",
      "Anti-Coagulation Drugs",
      "HBSAG / HCV / HIV (Serology)",
      "Bladder voided / Drainage",
      "Loose tooth / Dentures removed",
      "On any Medication - Specify",
    ],
    key: [
      "consent_high_risk",
      "preparation_of_parts",
      "surgical_site_marked",
      "jewels_removed",
      "hearing_aid_removed",
      "starvation_from",
      "bowel_preparation",
      "investigation_xray_ct_ecg",
      "premedication",
      "blood_requirements",
      "ot_dress_removed",
      "allergies",
      "specify",
      "iv_fluids_drugs_given",
      "ot_drugs_file_handed",
      "inj_tt_test_dose",
      "case_sheet_checked",
      "anti_coagulation",
      "hbsag_hcv_hiv",
      "bladder_voided",
      "loose_tooth_removed",
      "on_any_medication"
    ],
    key2: [
      "consent_high_risk_remarks",
      "preparation_of_parts_remarks",
      "surgical_site_marked_remarks",
      "jewels_removed_remarks",
      "hearing_aid_removed_remarks",
      "starvation_from_remarks",
      "bowel_preparation_remarks",
      "investigation_xray_ct_ecg_remarks",
      "premedication_remarks",
      "blood_requirements_remarks",
      "ot_dress_removed_remarks",
      "allergies_remarks",
      "specify_remarks",
      "iv_fluids_drugs_given_remarks",
      "ot_drugs_file_handed_remarks",
      "inj_tt_test_dose_remarks",
      "case_sheet_checked_remarks",
      "anti_coagulation_remarks",
      "hbsag_hcv_hiv_remarks",
      "bladder_voided_remarks",
      "loose_tooth_removed_remarks",
      "on_any_medication_remarks"
    ],

  }
];
const commonRemarks = [
  "Completed",
  "Not applicable",
  "Pending",
  "In progress",
  "To be done by nurse",
  "Verified",
  "Discuss with consultant",
];
const items = [{
  name: [
    "Epidural",
    "Central Line",
    "Feeding Jejunostomy",
    "Tracheostomy",
    "ICD",
    "Drain",
    "Ryle Tube",
  ],
  key: [
    "epidural", "central_line", "feeding_jejunostomy", "tracheostomy", "icd", "drain", "ryle_tube",
  ],
  key2: [
    "epidural_remarks",
    "central_line_remarks",
    "feeding_jejunostomy_remarks",
    "tracheostomy_remarks",
    "icd_remarks",
    "drain_remarks",
    "ryle_tube_remarks",
  ]
}];


const PreOperativeChecklist = () => {
  const { showNotification } = useNotification();
  const uhid_no = useParams().uhid_no;
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const validateField = (name, value) => {
    let error = "";
    switch (name) {
      case 'date':
        if (!value) error = "Date is required";
        break;
      case 'consultant':
        if (!value) error = "Consultant is required";
        break;
      case 'room_no':
        if (!value) error = "Room No. is required";
        break;
      default:
        break;
    }
    setErrors((prev) => ({ ...prev, [name]: error }));
    return error === "";
  };

  const handleBlur = (event) => {
    const { name, value } = event.target;
    validateField(name, value);
  };
  const [formData, setFormData] = useState({
    ip_no: "", // int(11)
    uhid_no: uhid_no || "", // int(11)
    name: "", // varchar(50)
    age: "", // int(11)
    sex: "", // enum('Male','Female','Other')
    blood_group: "", // varchar(10)
    weight: "", // varchar(10)
    room_no: "", // varchar(50)
    consultant: "", // varchar(255)
    diagnosis: "", // text
    date: "", // date
    consent_high_risk: "",
    consent_high_risk_remarks: "",
    consent_pre_operative: "", // enum('Yes','No','NA')
    consent_pre_operative_remarks: "", // text
    preparation_of_parts: "", // enum('Yes','No','NA')
    preparation_of_parts_remarks: "", // text
    surgical_site_marked: "", // enum('Yes','No','NA')
    surgical_site_marked_remarks: "", // text
    jewels_removed: "", // enum('Yes','No','NA')
    jewels_removed_remarks: "", // text
    hearing_aid_removed: "", // enum('Yes','No','NA')
    hearing_aid_removed_remarks: "", // text
    starvation_from: "", // enum('Yes','No','NA')
    starvation_from_remarks: "", // text
    bowel_preparation: "", // enum('Yes','No','NA')
    bowel_preparation_remarks: "", // text
    bowel_preparation_time: "", // time
    bowel_preparation_medication: "", // text
    investigation_xray_ct_ecg: "", // enum('Yes','No','NA')
    investigation_xray_ct_ecg_remarks: "", // text
    premedication: "", // enum('Yes','No','NA')
    premedication_remarks: "", // text
    blood_requirements: "", // enum('Yes','No','NA')
    blood_requirements_remarks: "", // text
    blood_units: "", // int(11)
    ot_dress_removed: "", // enum('Yes','No','NA')
    ot_dress_removed_remarks: "", // text
    allergies: "", // enum('Yes','No','NA')
    allergies_remarks: "", // text
    specify: "", // enum('Yes','No','NA')
    specify_remarks: "", // text
    iv_fluids_drugs_given: "", // enum('Yes','No','NA')
    iv_fluids_drugs_given_remarks: "", // text
    ot_drugs_file_handed: "", // enum('Yes','No','NA')
    ot_drugs_file_handed_remarks: "", // text
    inj_tt_test_dose: "", // enum('Yes','No','NA')
    inj_tt_test_dose_remarks: "", // text
    case_sheet_checked: "", // enum('Yes','No','NA')
    case_sheet_checked_remarks: "", // text
    anti_coagulation: "", // enum('Yes','No','NA')
    anti_coagulation_remarks: "", // text
    hbsag_hcv_hiv: "", // enum('Yes','No','NA')
    hbsag_hcv_hiv_remarks: "", // text
    bladder_voided: "", // enum('Yes','No','NA')
    bladder_voided_remarks: "", // text
    loose_tooth_removed: "", // enum('Yes','No','NA')
    loose_tooth_removed_remarks: "", // text
    on_any_medication: "", // enum('Yes','No','NA')
    on_any_medication_remarks: "", // text
    medication_details: "", // text
    vital_pr: "", // enum('Yes','No','NA')
    vital_pr_remarks: "", // text
    vital_bp: "", // enum('Yes','No','NA')
    vital_bp_remarks: "", // text
    vital_o2sat: "", // enum('Yes','No','NA')
    vital_o2sat_remarks: "", // text
    epidural: "", // enum('Yes','No')
    epidural_remarks: "", // text
    central_line: "", // enum('Yes','No')
    central_line_remarks: "", // text
    feeding_jejunostomy: "", // enum('Yes','No')
    feeding_jejunostomy_remarks: "", // text
    tracheostomy: "", // enum('Yes','No')
    tracheostomy_remarks: "", // text
    icd: "", // enum('Yes','No')
    icd_remarks: "", // text
    drain: "", // enum('Yes','No')
    drain_remarks: "", // text
    ryle_tube: "", // enum('Yes','No')
    ryle_tube_remarks: "", // text
    checklist_time: "", // datetime
    ward_nurse_signature: "", // blob
    ot_nurse_signature: "", // blob
    fild_completed_name: "", // varchar(100)
    fild_chaged_name: "", // varchar(100)
    file_completed_signature: "", // blob
    charge_nurse_signature: "", // blob
    shifted_to_ot_at: "", // datetime
    handed_over_by: "", // varchar(255)
    received_in_ot_at: "", // datetime
    taken_over_by: "", // varchar(255)
  });
  const handleNameChange = (e) => {
    const regex = /^[a-zA-Z\s.-]*$/; // allow letters, spaces, dot, hyphen
    const value = e.target.value;
    if (value === '' || regex.test(value)) {
      setFormData({ ...formData, [e.target.name]: value });
      if (errors[e.target.name]) {
        setErrors((prev) => ({ ...prev, [e.target.name]: '' }));
      }
    }
  };
  const navigate = useNavigate();

  const [success, setSuccess] = useState("");
  const fetchPatientData = async (uhidNo) => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_BASE_URL}/get_patient/${uhidNo}`);

      console.log(response.data);
      setFormData(prev => ({
        ...prev,

        name: response.data.name,
        age: response.data.age || "",
        sex: response.data.sex || "",

      }));
      setLoading(false);
    } catch (error) {
      console.error('Error fetching patient data:', error);

      setLoading(false);
    }
  };
  useEffect(() => {

    axios
      .get(`${API_BASE_URL}/get_pre_operative_checklist/${uhid_no}`)
      .then((response) => {
        const data = response.data;
        console.log('Backend data:', data);

        // Function to sanitize data: replace null with empty string
        const sanitizeData = (obj) => {
          return Object.keys(obj).reduce((acc, key) => {
            acc[key] = obj[key] === null ? '' : obj[key];
            return acc;
          }, {});
        };

        // Sanitize the received data
        const sanitizedData = sanitizeData(data);

        // Normalize vital fields to strings
        const normalizedData = {
          ...sanitizedData,
          vital_pr: sanitizedData.vital_pr === true ? "Yes" : sanitizedData.vital_pr === false ? "No" : sanitizedData.vital_pr,
          vital_bp: sanitizedData.vital_bp === true ? "Yes" : sanitizedData.vital_bp === false ? "No" : sanitizedData.vital_bp,
          vital_o2sat: sanitizedData.vital_o2sat === true ? "Yes" : sanitizedData.vital_o2sat === false ? "No" : sanitizedData.vital_o2sat,
        };

        // Handle date fields - separate date-only and datetime fields
        const dateOnlyFields = ['date'];
        const dateTimeFields = ['checklist_time', 'received_in_ot_at', 'shifted_to_ot_at'];

        const formattedDateData = dateOnlyFields.reduce((acc, field) => {
          if (normalizedData[field]) {
            // For date-only fields, keep as YYYY-MM-DD format
            if (/^\d{4}-\d{2}-\d{2}$/.test(normalizedData[field])) {
              acc[field] = normalizedData[field];
            } else {
              acc[field] = new Date(normalizedData[field]).toISOString().slice(0, 10);
            }
          }
          return acc;
        }, {});

        const formattedDateTimeData = dateTimeFields.reduce((acc, field) => {
          if (normalizedData[field]) {
            // If date string is in YYYY-MM-DD format, append 'T00:00' to make it ISO compatible for datetime-local input
            if (/^\d{4}-\d{2}-\d{2}$/.test(normalizedData[field])) {
              acc[field] = normalizedData[field] + 'T00:00';
            } else {
              acc[field] = new Date(normalizedData[field]).toISOString().slice(0, 16);
            }
          }
          return acc;
        }, {});

        // Handle bowel_preparation_time
        let bowelTime = '';
        if (normalizedData.bowel_preparation_time) {
          const parts = normalizedData.bowel_preparation_time.split(':');
          if (parts.length >= 2) {
            bowelTime = `${parts[0].padStart(2, '0')}:${parts[1].padStart(2, '0')}`;
          }
        }

        // Define signature fields
        const signatureFields = ['charge_nurse_signature', 'file_completed_signature', 'ot_nurse_signature', 'ward_nurse_signature'];

        // Update state with sanitized and formatted data
        setFormData({
          ...normalizedData,
          ...formattedDateData,
          ...formattedDateTimeData,
          bowel_preparation_time: bowelTime,
          ...signatureFields.reduce((acc, field) => {
            if (normalizedData[field]) {
              acc[field] = normalizedData[field];
            }
            return acc;
          }, {}),
        });

        setSuccess('success');
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      });
    fetchPatientData(uhid_no)
  }, [uhid_no]);

  // Load draft data if available
  useEffect(() => {
    if (uhid_no && hasDraft(DRAFT_KEYS.PREOPERATIVE_CHECKLIST, uhid_no)) {
      const saved = loadDraft(DRAFT_KEYS.PREOPERATIVE_CHECKLIST, uhid_no);
      if (saved && saved.formData) {
        setFormData(saved.formData);
      }
    }
  }, [uhid_no]);


  // Fetch next UHID & IP_No on component mount
  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const [ipRes] = await Promise.all([

          axios.get(`${API_BASE_URL}/get_preop_next_ip`)
        ]);
        setFormData(prev => ({
          ...prev,

          ip_no: ipRes.data.next_ip_no
        }));
      } catch (error) {
        console.error('Failed to fetch initial data:', error);
      }
    };

    fetchInitialData();
  }, []);


  const handleChange = (event) => {
    if (!event || !event.target) return;

    // Prevent errors if event is undefined
    const { name, type, checked, value } = event.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
    if (errors[name]) {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const handleCheckboxChange = (item, value) => {
    setFormData(prev => ({
      ...prev,
      [item]: value
    }));
  };

  const [signatureDialogOpen, setSignatureDialogOpen] = useState(false);
  const [currentSignatureRole, setCurrentSignatureRole] = useState("");
  const signaturePadRef = useRef(null);

  const handleSignatureOpen = (role) => {
    setCurrentSignatureRole(role);
    setSignatureDialogOpen(true);
  };
  const handleSignatureClose = () => {
    setSignatureDialogOpen(false)
  }
  const handleSignatureClear = () => {
    signaturePadRef.current.clear();
  };

  const handleSignatureSave = () => {
    const dataURL = signaturePadRef.current.toDataURL();
    setFormData((prevSignatures) => ({
      ...prevSignatures,
      [currentSignatureRole]: dataURL.split(',')[1],
    }));
    setSignatureDialogOpen(false);
  };
  const validate = () => {
    const requiredFields = [
      { key: 'date',       label: 'Surgery Date'   },
      { key: 'consultant', label: 'Consultant Name' },
      { key: 'room_no',    label: 'Room No.'        },
    ];
    const tempErrors = {};
    requiredFields.forEach(({ key, label }) => {
      if (!formData[key] || String(formData[key]).trim() === '')
        tempErrors[key] = `${label} is required`;
    });
    setErrors(tempErrors);
    if (Object.keys(tempErrors).length > 0) {
      const firstKey = Object.keys(tempErrors)[0];
      const el = document.querySelector(`[name="${firstKey}"]`);
      if (el) { el.scrollIntoView({ behavior: 'smooth', block: 'center' }); el.focus(); }
      showNotification('error', requiredFields.filter(f => tempErrors[f.key]).map(f => f.label));
    }
    return Object.keys(tempErrors).length === 0;
  };
  const [savedData, setSavedData] = useState(null);
  const [showSaveNotification, setShowSaveNotification] = useState(false);
  const [currentPage, setCurrentPage] = useState('form');
  const [dataLoaded, setDataLoaded] = useState(false);
  // Auto-save functionality
  // Auto-save functionality - only after initial data is loaded
  useEffect(() => {
    if (!dataLoaded) return; // Don't auto-save until initial data is loaded

    const timeoutId = setTimeout(() => {
      if (hasFormData()) {
        saveFormData(formData);
        setShowSaveNotification(true);
        setTimeout(() => setShowSaveNotification(false), 2000);
      }
    }, 2000);

    return () => clearTimeout(timeoutId);
  }, [formData, dataLoaded]);

  // Save form data to sessionStorage
  const saveFormData = (data) => {
    sessionStorage.setItem(`pre_operativeForm_${uhid_no}`, JSON.stringify(data));
    console.log('Form data saved:', data);
  };

  // Get saved form data
  const getSavedFormData = () => {
    const saved = sessionStorage.getItem(`pre_operativeForm_${uhid_no}`);
    return saved ? JSON.parse(saved) : null;
  };

  // Check if form has any data
  const hasFormData = () => {
    return Object.values(formData).some(value => {
      if (typeof value === 'string') return value.trim() !== '';
      if (typeof value === 'object' && value !== null) {
        return Object.values(value).some(subValue =>
          typeof subValue === 'string' ? subValue.trim() !== '' : !!subValue
        );
      }
      // For booleans, just check if true
      if (typeof value === 'boolean') return value === true;
      // For numbers, check if not null/undefined
      if (typeof value === 'number') return value !== null && value !== undefined;
      return false;
    });
  };

  // Clear saved data - ONLY called on successful submit
  const clearSavedData = () => {
    setSavedData(null);
    sessionStorage.removeItem(`pre_operativeForm_${uhid_no}`);
    sessionStorage.removeItem(`formStatus_pre_operative_${uhid_no}`);
  };

  // Home button handler
  const handleHomeNavigation = () => {
    if (hasFormData()) {
      saveFormData(formData);
      // Store form status for home page to show "Continue" button
      sessionStorage.setItem(`formStatus_pre_operative_${uhid_no}`, JSON.stringify({
        formName: 'PRE-OPERATIVE CHECKLIST',
        uhid_no: uhid_no,
        status: 'incomplete',
        lastSaved: new Date().toISOString(),
        continueUrl: `/preOperativeChecklist/${uhid_no}`
      }));
    }
    navigate('/home');
  };
  useEffect(() => {
    const saved = getSavedFormData();
    if (saved && Object.keys(saved).length > 0) {
      setSavedData(saved);
      setFormData(saved);
    }
  }, []);
  const handleBack = () => {
    navigate(`/mainPage/${formData.uhid_no}`, {
      state: { from: 'PreOperativePhase', status: 'success', step: 1 },
    }); // Navigate to the previous page
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    console.log("Form data:", formData);
    if (!validate()) return;
    const data = {
      ip_no: formData.ip_no,
      uhid_no: formData.uhid_no,
      name: formData.name,
      age: formData.age,
      sex: formData.sex,
      blood_group: formData.blood_group,
      weight: formData.weight,
      room_no: formData.room_no,
      consultant: formData.consultant,
      diagnosis: formData.diagnosis,
      date: formData.date,
      consent_high_risk: formData.consent_high_risk,
      consent_high_risk_remarks: formData.consent_high_risk_remarks,
      consent_pre_operative: formData.consent_pre_operative,
      consent_pre_operative_remarks: formData.consent_pre_operative_remarks,
      preparation_of_parts: formData.preparation_of_parts,
      preparation_of_parts_remarks: formData.preparation_of_parts_remarks,
      surgical_site_marked: formData.surgical_site_marked,
      surgical_site_marked_remarks: formData.surgical_site_marked_remarks,
      jewels_removed: formData.jewels_removed,
      jewels_removed_remarks: formData.jewels_removed_remarks,
      hearing_aid_removed: formData.hearing_aid_removed,
      hearing_aid_removed_remarks: formData.hearing_aid_removed_remarks,
      starvation_from: formData.starvation_from,
      starvation_from_remarks: formData.starvation_from_remarks,
      bowel_preparation: formData.bowel_preparation,
      bowel_preparation_remarks: formData.bowel_preparation_remarks,
      bowel_preparation_time: formData.bowel_preparation_time,
      bowel_preparation_medication: formData.bowel_preparation_medication,
      investigation_xray_ct_ecg: formData.investigation_xray_ct_ecg,
      investigation_xray_ct_ecg_remarks: formData.investigation_xray_ct_ecg_remarks,
      premedication: formData.premedication,
      premedication_remarks: formData.premedication_remarks,
      blood_requirements: formData.blood_requirements,
      blood_requirements_remarks: formData.blood_requirements_remarks,
      blood_units: formData.blood_units,
      ot_dress_removed: formData.ot_dress_removed,
      ot_dress_removed_remarks: formData.ot_dress_removed_remarks,
      allergies: formData.allergies,
      allergies_remarks: formData.allergies_remarks,
      specify: formData.specify,
      specify_remarks: formData.specify_remarks,
      iv_fluids_drugs_given: formData.iv_fluids_drugs_given,
      iv_fluids_drugs_given_remarks: formData.iv_fluids_drugs_given_remarks,
      ot_drugs_file_handed: formData.ot_drugs_file_handed,
      ot_drugs_file_handed_remarks: formData.ot_drugs_file_handed_remarks,
      inj_tt_test_dose: formData.inj_tt_test_dose,
      inj_tt_test_dose_remarks: formData.inj_tt_test_dose_remarks,
      case_sheet_checked: formData.case_sheet_checked,
      case_sheet_checked_remarks: formData.case_sheet_checked_remarks,
      anti_coagulation: formData.anti_coagulation,
      anti_coagulation_remarks: formData.anti_coagulation_remarks,
      hbsag_hcv_hiv: formData.hbsag_hcv_hiv,
      hbsag_hcv_hiv_remarks: formData.hbsag_hcv_hiv_remarks,
      bladder_voided: formData.bladder_voided,
      bladder_voided_remarks: formData.bladder_voided_remarks,
      loose_tooth_removed: formData.loose_tooth_removed,
      loose_tooth_removed_remarks: formData.loose_tooth_removed_remarks,
      on_any_medication: formData.on_any_medication,
      on_any_medication_remarks: formData.on_any_medication_remarks,
      medication_details: formData.medication_details,
      vital_pr: formData.vital_pr || "No",
      vital_pr_remarks: formData.vital_pr_remarks,
      vital_bp: formData.vital_bp || "No",
      vital_bp_remarks: formData.vital_bp_remarks,
      vital_o2sat: formData.vital_o2sat || "No",
      vital_o2sat_remarks: formData.vital_o2sat_remarks,
      epidural: formData.epidural,
      epidural_remarks: formData.epidural_remarks,
      central_line: formData.central_line,
      central_line_remarks: formData.central_line_remarks,
      feeding_jejunostomy: formData.feeding_jejunostomy,
      feeding_jejunostomy_remarks: formData.feeding_jejunostomy_remarks,
      tracheostomy: formData.tracheostomy,
      tracheostomy_remarks: formData.tracheostomy_remarks,
      icd: formData.icd,
      icd_remarks: formData.icd_remarks,
      drain: formData.drain,
      drain_remarks: formData.drain_remarks,
      ryle_tube: formData.ryle_tube,
      ryle_tube_remarks: formData.ryle_tube_remarks,
      checklist_time: formData.checklist_time,
      ward_nurse_signature: formData.ward_nurse_signature,
      ot_nurse_signature: formData.ot_nurse_signature,
      fild_completed_name: formData.fild_completed_name,
      fild_chaged_name: formData.fild_chaged_name,
      file_completed_signature: formData.file_completed_signature,
      charge_nurse_signature: formData.charge_nurse_signature,
      shifted_to_ot_at: formData.shifted_to_ot_at,
      handed_over_by: formData.handed_over_by,
      received_in_ot_at: formData.received_in_ot_at,
      taken_over_by: formData.taken_over_by,
    };

    try {
      if (success === "success") {
        const responseUpdate = await axios.put(`${API_BASE_URL}/update_pre_operative_checklist/${uhid_no}`, data);

        showNotification('success', 'Pre-Operative Checklist updated successfully!');
      } else {
        const response = await axios.post(`${API_BASE_URL}/pre_operative_checklist`, data);
        console.log('Pre-Operative Checklist Response: ', response.data);
        showNotification('success', 'Pre-Operative Checklist submitted successfully!');
      }
      clearSavedData();
      navigate(`/mainPage/${formData.uhid_no}`, {
        state: { from: 'PreOperativePhase', status: 'success', step: 1 },
      });
    } catch (error) {
      console.error('Error submitting the form!', error.response ? error.response.data : error);
      showNotification('error', 'Error in submitting Pre-Operative Checklist!');
    }
  };

  const medicationOptions = [
    "Paracetamol",
    "Ibuprofen",
    "Amoxicillin",
    "Insulin",
    "Aspirin",
    "Metformin",
    "Omeprazole",
  ];
  const diagnosisOptions = [
    "Hypertension",
    "Diabetes",
    "Asthma",
    "COVID-19",
    "Pneumonia",
    "Migraine",
    "Anemia",
  ];
  const bowelPrepMedications = [
    "Polyethylene Glycol (PEG)",
    "Bisacodyl",
    "Sodium Phosphate",
    "Magnesium Citrate",
    "Senna",
    "Lactulose",
  ];
  const goToVideoRecorder = (formName, uhid_no) => {
    navigate(`/video?form=${encodeURIComponent(formName)}&uhid_no=${encodeURIComponent(uhid_no)}`);
  };
  const [submitStatus, setSubmitStatus] = useState({
    open: false,
    message: "",
    severity: "success"
  });
  const handleShareClick = async () => {
    try {
      // Call API to generate a share token for the given UHID
      const res = await axios.post(`${API_BASE_URL}/generate_for_preop_checklist_api_share_token/${uhid_no}`);

      const token = res.data.token;
      const link = `${API_BASE_URL}/preOperativeChecklist/${uhid_no}?token=${token}`;
      const message = `Dear Doctor,\n\nPlease fill the post-operative analgesia chart:\n\n${link}`;

      // Copy the shareable link to clipboard
      await navigator.clipboard.writeText(link);

      // Show success notification to user
      setSubmitStatus({
        open: true,
        message: "Secure link copied to clipboard!",
        severity: "info",
      });

      // Open WhatsApp chat with pre-filled message (replace phone number if needed)
      const phoneNumber = '+916379605575'; // no spaces or special chars for wa.me
      window.open(`http://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`, '_blank');
    } catch (error) {
      console.error("Error generating share token:", error);

      // Show error notification to user
      setSubmitStatus({
        open: true,
        message: "Failed to generate shareable link",
        severity: "error",
      });
    }
  };
  const doctorGroups = {
    Cardiologists: [
      "Dr. John Smith",
      "Dr. Emily Johnson",
      "Dr. Michael Brown",
      "Dr. Sarah Davis",
      "Dr. William Wilson",
      "Dr. Linda Martinez"
    ],
    Neurologists: [
      "Dr. Robert Lee",
      "Dr. Patricia Taylor",
      "Dr. James Anderson",
      "Dr. Barbara Thomas",
      "Dr. David Jackson",
      "Dr. Susan White"
    ],
    Orthopedics: [
      "Dr. Richard Garcia",
      "Dr. Jennifer Harris",
      "Dr. Charles Clark",
      "Dr. Jessica Lewis",
      "Dr. Thomas Robinson",
      "Dr. Karen Walker"
    ],
    Dermatologists: [
      "Dr. Nancy Young",
      "Dr. Matthew Hall",
      "Dr. Donna Allen",
      "Dr. Steven King",
      "Dr. Michelle Wright",
      "Dr. George Scott"
    ],
    Gynecologists: [
      "Dr. Sandra Green",
      "Dr. Kevin Adams",
      "Dr. Laura Baker",
      "Dr. Mark Nelson",
      "Dr. Angela Carter",
      "Dr. Brian Mitchell"
    ],
    Pediatricians: [
      "Dr. Melissa Perez",
      "Dr. Eric Roberts",
      "Dr. Deborah Turner",
      "Dr. Jason Phillips",
      "Dr. Rebecca Campbell",
      "Dr. Andrew Parker"
    ],
    AnaesthesiaSpecialists: [
      "Dr. Anil Mehta",
      "Dr. Priya Iyer",
      "Dr. Rakesh Nair",
      "Dr. Neha Sharma",
      "Dr. Vivek Rao",
      "Dr. Aarti Desai"
    ]
  };
  const nurseGroups = {
    ICU: [
      "Nurse Anna Smith",
      "Nurse Brian Lee",
      "Nurse Carol White",
      "Nurse David Green",
      "Nurse Emma Black",
      "Nurse Frank Harris",
    ],
    Pediatrics: [
      "Nurse Emily Davis",
      "Nurse Frank Miller",
      "Nurse Grace Wilson",
      "Nurse Hannah Moore",
      "Nurse Ian Clark",
      "Nurse Julia Lewis",
    ],
    GeneralWard: [
      "Nurse Henry Brown",
      "Nurse Irene Clark",
      "Nurse Jack Harris",
      "Nurse Kelly Martinez",
      "Nurse Liam Thompson",
      "Nurse Mia Anderson",
    ],
    Emergency: [
      "Nurse Karen Scott",
      "Nurse Larry Adams",
      "Nurse Monica Turner",
      "Nurse Nathan Hill",
      "Nurse Olivia King",
      "Nurse Peter Wright",
    ],
    Surgery: [
      "Nurse Quinn Young",
      "Nurse Rachel Walker",
      "Nurse Samuel Hall",
      "Nurse Tina Allen",
      "Nurse Victor Baker",
      "Nurse Wendy Nelson",
    ],
    Maternity: [
      "Nurse Xavier Perez",
      "Nurse Yolanda Roberts",
      "Nurse Zoe Campbell",
      "Nurse Aaron Phillips",
      "Nurse Bethany Parker",
      "Nurse Chris Turner",
    ],
  };

  const weightOptions = [
    "40 kg", "45 kg", "50 kg", "55 kg", "60 kg", "65 kg", "70 kg", "75 kg", "80 kg", "85 kg", "90 kg", "95 kg", "100 kg"];
  const bloodGroupOptions = ["A+", "A−", "B+", "B−", "AB+", "AB−", "O+", "O−"];
  const roomNoOptions = ["101", "102", "103", "201", "202", "203", "301", "302", "401", "ICU-1", "ICU-2"];
  return (
    <ThemeProvider theme={theme}>
      <Container maxWidth="md" sx={{ marginTop: 4, marginBottom: 4 }}>
        <Paper elevation={3} sx={{ padding: 3 }}>


          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: 2 }}>
            {/* Heading with Icon */}
            <Typography
              variant="h4"
              sx={{
                color: '#008080',
                display: 'flex',
                alignItems: 'center',
                fontWeight: 600,
                letterSpacing: 0.5,
              }}
            >

              PRE-OPERATIVE CHECKLIST
            </Typography>

            {/* Right-aligned Logo and Text */}
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <img src="/logo.png" alt="Logo" className="w-8 h-8" />
              <Typography
                variant="h6"
                sx={{
                  color: '#008080',
                  marginLeft: 1,
                  fontWeight: 500,
                  letterSpacing: 0.3,
                }}
              >
                OTMS
              </Typography>
            </Box>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 2 }}>
            {/* Left-aligned Back Button */}
            <Button
              variant="outlined"
              onClick={handleBack}
              sx={{ marginLeft: 2 }}
            >
              Back
            </Button>

            {/* Right-aligned Buttons */}
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Button
                variant="contained"
                onClick={handleHomeNavigation}
                sx={{ marginRight: 1 }}
              >
                Home
              </Button>
              <Button
                variant="contained"
                onClick={() => goToVideoRecorder("PRE-OPERATIVE CHECKLIST", uhid_no)}
                sx={{ marginRight: 1 }}
              >
                Add Iterative Video
              </Button>
              <IconButton color="primary" aria-label="share" onClick={handleShareClick}>
                <ShareIcon />
              </IconButton>
            </Box>
          </Box>
          <br></br>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField label="Patient Name" name="name" InputProps={{ readOnly: true, }} fullWidth onChange={handleNameChange} value={formData.name} />
              </Grid>
              <Grid item xs={6} sm={3}>
                <TextField
                  label="Date"
                  type="date"
                  name="date"
                  value={formData.date}
                  onChange={handleChange}
                  fullWidth
                  required
                  InputLabelProps={{ shrink: true }}
                  error={!!errors.date}
                  helperText={errors.date}
                  onBlur={handleBlur}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  label="Room No"
                  name="room_no"
                  value={formData.room_no}
                  onChange={handleChange}
                  fullWidth
                  required
                  error={!!errors.room_no}
                  helperText={errors.room_no}
                  onBlur={handleBlur}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth required error={!!errors.consultant}>
                  <InputLabel id="consultant-label">Consultant</InputLabel>
                  <Select
                    labelId="consultant-label"
                    label="Consultant"
                    name="consultant"
                    value={formData.consultant || ""}
                    onChange={handleNameChange}
                    onBlur={handleBlur}
                  >
                    <MenuItem value="">
                      <em>Select Doctor</em>
                    </MenuItem>
                    {Object.entries(doctorGroups).map(([specialty, doctors]) => [
                      <ListSubheader key={specialty}>{specialty}</ListSubheader>,
                      doctors.map((doctor, idx) => (
                        <MenuItem key={`${specialty}-${idx}`} value={doctor}>
                          {doctor}
                        </MenuItem>
                      ))
                    ])}
                  </Select>
                  {errors.consultant && <FormHelperText>{errors.consultant}</FormHelperText>}
                </FormControl>
              </Grid>
              <Grid item xs={6} sm={3}>
                <Autocomplete
                  freeSolo
                  options={weightOptions || []}
                  inputValue={formData.weight}
                  onInputChange={(event, newInputValue) => {
                    handleChange({
                      target: { name: "weight", value: newInputValue }
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Weight"
                      name="weight"
                      fullWidth
                    />
                  )}
                />
              </Grid>
              <Grid item xs={6} sm={3}>
                <TextField label="UHID No" name="uhid_no" fullWidth onChange={handleChange} value={formData.uhid_no} InputProps={{ readOnly: true, }} />
              </Grid>
              <Grid item xs={6} sm={3}>

                <FormControl fullWidth variant="outlined">
                  <InputLabel>Blood Type</InputLabel>
                  <Select
                    name="blood_group"
                    value={formData.blood_group}
                    onChange={handleChange}
                    label="Blood Type"
                  >
                    <MenuItem value=""><em>None</em></MenuItem>
                    <MenuItem value="A+">A+</MenuItem>
                    <MenuItem value="A-">A-</MenuItem>
                    <MenuItem value="B+">B+</MenuItem>
                    <MenuItem value="B-">B-</MenuItem>
                    <MenuItem value="AB+">AB+</MenuItem>
                    <MenuItem value="AB-">AB-</MenuItem>
                    <MenuItem value="O+">O+</MenuItem>
                    <MenuItem value="O-">O-</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6} sm={3}>
                <FormControl fullWidth>
                  <InputLabel id="room-no-label">Room No</InputLabel>
                  <Select
                    labelId="room-no-label"
                    id="room-no-select"
                    name="room_no"
                    value={formData.room_no || ''}
                    label="Room No"
                    onChange={handleChange}
                  >
                    <MenuItem value="">
                      <em>Select Room</em>
                    </MenuItem>
                    {roomNoOptions && roomNoOptions.map((room, index) => (
                      <MenuItem key={index} value={room}>
                        {room}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6} sm={3}>
                <TextField label="Date" inputProps={{
                  min: new Date().toISOString().slice(0, 16), // prevents past dates
                }} error={Boolean(errors.date)}
                  helperText={errors.date} name="date" type="date" InputLabelProps={{ shrink: true }} fullWidth onChange={handleChange} value={formData.date} />
              </Grid>
              <Grid item xs={6} sm={3}>
                <TextField label="IP No" InputProps={{ readOnly: true, }} name="ip_no" fullWidth onChange={handleChange} value={formData.ip_no} />
              </Grid>
              <Grid item xs={12}>
                <Autocomplete
                  freeSolo
                  options={diagnosisOptions || []}
                  inputValue={formData.diagnosis}
                  onInputChange={(event, newInputValue) => {
                    handleChange({
                      target: { name: "diagnosis", value: newInputValue }
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Diagnosis"
                      name="diagnosis"
                      fullWidth
                    />
                  )}
                />
              </Grid>
            </Grid>
            <Divider sx={{ my: 2 }} />
            <TableContainer
              component={Paper}
              sx={{
                overflowX: 'auto',
                maxWidth: '100vw',
                '& table': {
                  tableLayout: 'fixed',
                  width: '100%',
                  minWidth: 850, // ensure enough width for columns
                },
              }}
            >
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ width: 30, whiteSpace: 'nowrap' }}>No</TableCell>
                    <TableCell sx={{ width: 300, whiteSpace: 'normal' }}>Special Informations</TableCell>
                    <TableCell sx={{ width: 50 }}>Yes</TableCell>
                    <TableCell sx={{ width: 50 }}>No</TableCell>
                    <TableCell sx={{ width: 50 }}>NA</TableCell>
                    <TableCell sx={{ width: 100, whiteSpace: 'normal' }}>Remarks</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {checklistItems[0].key.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell sx={{ whiteSpace: 'nowrap' }}>{index + 1}</TableCell>
                      <TableCell sx={{ whiteSpace: 'normal' }}>{checklistItems[0].name[index]}</TableCell>
                      <TableCell>
                        <Checkbox
                          checked={formData[item] === "Yes"}
                          onChange={() => handleCheckboxChange(item, "Yes")}
                        />
                      </TableCell>
                      <TableCell>
                        <Checkbox
                          checked={formData[item] === "No"}
                          onChange={() => handleCheckboxChange(item, "No")}
                        />
                      </TableCell>
                      <TableCell>
                        <Checkbox
                          checked={formData[item] === "NA"}
                          onChange={() => handleCheckboxChange(item, "NA")}
                        />
                      </TableCell>
                      <TableCell sx={{ width: 400, padding: 0 }}>
                        <Autocomplete
                          freeSolo
                          options={commonRemarks || []}
                          value={formData[`${item}_remarks`] || ""}
                          onChange={(event, newValue) => {
                            handleChange({
                              target: {
                                name: `${item}_remarks`,
                                value: newValue || "",
                              },
                            });
                          }}
                          onInputChange={(event, newInputValue) => {
                            handleChange({
                              target: {
                                name: `${item}_remarks`,
                                value: newInputValue,
                              },
                            });
                          }}
                          sx={{ width: '100%' }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              multiline
                              minRows={2}
                              placeholder="Remarks"
                              variant="outlined"
                              size="small"
                              sx={{ width: '100%', boxSizing: 'border-box', padding: '8px' }}
                            />
                          )}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Divider sx={{ my: 2 }} />
            <Grid container spacing={4}>
              <Grid item xs={12}>
                <Autocomplete
                  freeSolo
                  options={medicationOptions || []}
                  inputValue={formData.medication_details}
                  onInputChange={(event, newInputValue) => {
                    handleChange({
                      target: { name: 'medication_details', value: newInputValue }
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Medication details"
                      variant="outlined"
                      fullWidth
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="h6">Blood units</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Autocomplete
                  freeSolo
                  options={["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"] || []}
                  inputValue={formData.blood_units}
                  onInputChange={(event, newInputValue) => {
                    handleChange({
                      target: { name: 'blood_units', value: newInputValue }
                    });
                  }
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="No Of Blood Units"
                      fullWidth
                    />
                  )}
                />
              </Grid>
              <Divider sx={{ my: 2 }} />
              <Grid item xs={12} sm={6}>
                <Typography variant="h6">Vital Signs / CBG</Typography>
              </Grid>
              <Grid item xs={12} sm={1}>
                PR
                <Checkbox
                  checked={formData.vital_pr === "Yes"}
                  onChange={() => handleCheckboxChange("vital_pr", formData.vital_pr === "Yes" ? "No" : "Yes")}
                  name="vital_pr"
                />
              </Grid>
              <Grid item xs={12} sm={1}>
                BP
                <Checkbox
                  checked={formData.vital_bp === "Yes"}
                  onChange={() => handleCheckboxChange("vital_bp", formData.vital_bp === "Yes" ? "No" : "Yes")}
                  name="vital_bp"
                />
              </Grid>
              <Grid item xs={12} sm={1}>
                O2Sat
                <Checkbox
                  checked={formData.vital_o2sat === "Yes"}
                  onChange={() => handleCheckboxChange("vital_o2sat", formData.vital_o2sat === "Yes" ? "No" : "Yes")}
                  name="vital_o2sat"
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <Autocomplete
                  freeSolo
                  options={commonRemarks || []}
                  inputValue={formData.vital_pr_remarks || ""}
                  onInputChange={(event, newInputValue) => {
                    handleChange({
                      target: { name: "vital_pr_remarks", value: newInputValue }
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Remarks"
                      fullWidth
                      name="vital_pr_remarks"
                    />
                  )}
                />
              </Grid>
            </Grid>
            <Divider sx={{ my: 2 }} />
            <TableContainer
              component={Paper}
              sx={{
                overflowX: 'auto',
                maxWidth: '100vw',
                '& table': {
                  tableLayout: 'fixed',
                  width: '100%',
                  minWidth: 850, // ensure enough width for columns
                },
              }}
            >
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ width: 30, whiteSpace: 'nowrap' }}>No</TableCell>
                    <TableCell sx={{ width: 300, whiteSpace: 'normal' }}>Special Informations</TableCell>
                    <TableCell sx={{ width: 50 }}>Yes</TableCell>
                    <TableCell sx={{ width: 50 }}>No</TableCell>

                    <TableCell sx={{ width: 100, whiteSpace: 'normal' }}>Remarks</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {items[0].key.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell sx={{ whiteSpace: 'nowrap' }}>{index + 1}</TableCell>
                      <TableCell sx={{ whiteSpace: 'normal' }}>{checklistItems[0].name[index]}</TableCell>
                      <TableCell>
                        <Checkbox
                          checked={formData[item] === "Yes"}
                          onChange={() => handleCheckboxChange(item, "Yes")}
                        />
                      </TableCell>
                      <TableCell>
                        <Checkbox
                          checked={formData[item] === "No"}
                          onChange={() => handleCheckboxChange(item, "No")}
                        />
                      </TableCell>

                      <TableCell sx={{ width: 400, padding: 0 }}>
                        <Autocomplete
                          freeSolo
                          options={commonRemarks || []}
                          value={formData[`${item}_remarks`] || ""}
                          onChange={(event, newValue) => {
                            handleChange({
                              target: {
                                name: `${item}_remarks`,
                                value: newValue || "",
                              },
                            });
                          }}
                          onInputChange={(event, newInputValue) => {
                            handleChange({
                              target: {
                                name: `${item}_remarks`,
                                value: newInputValue,
                              },
                            });
                          }}
                          sx={{ width: '100%' }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              multiline
                              minRows={2}
                              placeholder="Remarks"
                              variant="outlined"
                              size="small"
                              sx={{ width: '100%', boxSizing: 'border-box', padding: '8px' }}
                            />
                          )}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <br />
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <TextField
                  type="datetime-local"
                  label="Checklist Time"
                  inputProps={{
                    min: new Date().toISOString().slice(0, 16), // prevents past dates
                  }}
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  name="checklist_time"
                  value={formData.checklist_time}
                  onChange={handleChange}
                />
              </Grid>
              {[{
                label: "Sig. Of Ward Duty Nurse",
                key: "ward_nurse_signature",

              },
              {
                label: "Sig. Of OT Charge Nurse",
                key: "ot_nurse_signature",

              },

              ].map((person, index) => (
                <Grid item xs={12} sm={6} key={person.key}>

                  <Typography >{person.label} </Typography>
                  <Button variant="outlined" color="primary" sx={{ marginTop: 2 }} onClick={() => handleSignatureOpen(person.key)}>
                    Sign Here
                  </Button>
                  {formData[person.key] && (
                    <img src={`data:image/png;base64,${formData[person.key]}`} alt="Signature" style={{ marginTop: 10, border: '1px solid black', width: '100%', height: '150px' }} />
                  )}
                </Grid>
              ))}
            </Grid>
            <Dialog open={signatureDialogOpen} onClose={() => setSignatureDialogOpen(false)}>
              <DialogTitle>Provide Your Signature</DialogTitle>
              <DialogContent>
                <SignatureCanvas ref={signaturePadRef} canvasProps={{ width: 400, height: 200, className: 'sigCanvas' }} />
              </DialogContent>
              <DialogActions>
                <Button onClick={handleSignatureClear} color="secondary">Clear</Button>
                <Button onClick={handleSignatureSave} >Done</Button>
                <Button onClick={handleSignatureClose} color="secondary">Close</Button>
              </DialogActions>
            </Dialog>
            <br></br>

            <Typography variant="h6" sx={{ mt: 2 }}>
              Bowel Preparation
            </Typography>
            <Grid container spacing={6} >
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Time"
                  type="time"
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  name="bowel_preparation_time"
                  value={formData.bowel_preparation_time}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Autocomplete
                  freeSolo
                  options={bowelPrepMedications || []}
                  inputValue={formData.bowel_preparation_medication || ""}
                  onInputChange={(event, newInputValue) => {
                    handleChange({
                      target: { name: "bowel_preparation_medication", value: newInputValue }
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Medication"
                      fullWidth
                      name="bowel_preparation_medication"
                    />
                  )}
                />
              </Grid>
            </Grid>

            <Typography variant="h6" sx={{ mt: 2 }}>
              File Completion
            </Typography>
            <Grid container spacing={6} >
              {[{
                label: "File Completed By Name of Nurse",
                key: "file_completed_signature",
                key1: "fild_completed_name"
              },
              {
                label: "File Checked By Name of Nurse",
                key: "charge_nurse_signature",
                key1: "fild_chaged_name"
              },
              ].map((person, index) => (

                <Grid item xs={12} sm={6} key={person.key}>

                  <FormControl fullWidth sx={{ marginTop: 1 }}>
                    <InputLabel id={`${person.key1}-label`}>Name ({person.label})</InputLabel>
                    <Select
                      labelId={`${person.key1}-label`}
                      id={person.key1}
                      name={person.key1}
                      value={formData[person.key1] || ""}
                      label={`Name (${person.label})`}
                      onChange={handleNameChange}
                      required
                    >
                      <MenuItem value="">
                        <em>Select Nurse</em>
                      </MenuItem>
                      {Object.entries(nurseGroups).map(([groupName, nurses]) => (
                        <ListSubheader key={groupName}>{groupName}</ListSubheader>,
                        nurses.map((nurse, idx) => (
                          <MenuItem key={`${groupName}-${idx}`} value={nurse}>
                            {nurse}
                          </MenuItem>
                        ))
                      ))}
                    </Select>
                  </FormControl>
                  <Button variant="outlined" color="primary" sx={{ marginTop: 2 }} onClick={() => handleSignatureOpen(person.key)}>
                    Sign Here
                  </Button>
                  {formData[person.key] && (
                    <img src={`data:image/png;base64,${formData[person.key]}`} alt="Signature" style={{ marginTop: 10, border: '1px solid black', width: '100%', height: '150px' }} />
                  )}
                </Grid>
              ))}
            </Grid>
            <Dialog open={signatureDialogOpen} onClose={() => setSignatureDialogOpen(false)}>
              <DialogTitle>Provide Your Signature</DialogTitle>
              <DialogContent>
                <SignatureCanvas ref={signaturePadRef} canvasProps={{ width: 400, height: 200, className: 'sigCanvas' }} />
              </DialogContent>
              <DialogActions>
                <Button onClick={handleSignatureClear} color="secondary">Clear</Button>
                <Button onClick={handleSignatureSave} >Done</Button>
                <Button onClick={handleSignatureClose} color="secondary">Close</Button>

              </DialogActions>
            </Dialog>
            <br></br>
            <TextField
              fullWidth
              label="Shifted to OT At"
              value={formData.shifted_to_ot_at}
              InputLabelProps={{ shrink: true }}
              type="datetime-local"
              inputProps={{
                min: new Date().toISOString().slice(0, 16), // prevents past dates
              }}
              name="shifted_to_ot_at"
              onChange={handleChange}
              sx={{ mb: 2 }}
            />
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel id="handed-over-by-label">Handed Over By</InputLabel>
              <Select
                labelId="handed-over-by-label"
                name="handed_over_by"
                value={formData.handed_over_by || ""}
                label="Handed Over By"
                onChange={handleNameChange}
                required
              >
                <MenuItem value="">
                  <em>Select Nurse</em>
                </MenuItem>
                {Object.entries(nurseGroups).map(([group, nurses]) => [
                  <ListSubheader key={group}>{group}</ListSubheader>,
                  nurses.map((nurse, idx) => (
                    <MenuItem key={`${group}-${idx}`} value={nurse}>
                      {nurse}
                    </MenuItem>
                  )),
                ])}
              </Select>
            </FormControl>
            <TextField
              fullWidth
              label="Received in OT At"
              type="datetime-local"
              name="received_in_ot_at"
              InputLabelProps={{ shrink: true }}
              value={formData.received_in_ot_at}
              onChange={handleChange}
              inputProps={{
                min: new Date().toISOString().slice(0, 16), // prevents past dates
              }}
              sx={{ mb: 2 }}
            />

            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel id="taken-over-by-label">Taken Over By</InputLabel>
              <Select
                labelId="taken-over-by-label"
                name="taken_over_by"
                value={formData.taken_over_by || ""}
                label="Taken Over By"
                onChange={handleNameChange}
                required
              >
                <MenuItem value="">
                  <em>Select Nurse</em>
                </MenuItem>
                {Object.entries(nurseGroups).map(([group, nurses]) => [
                  <ListSubheader key={group}>{group}</ListSubheader>,
                  nurses.map((nurse, idx) => (
                    <MenuItem key={`${group}-${idx}`} value={nurse}>
                      {nurse}
                    </MenuItem>
                  )),
                ])}
              </Select>
            </FormControl>
            <Grid item xs={12}>
              <Box sx={{ display: 'flex', gap: 2, marginTop: 3 }}>

                <DraftSaveButton
                  formKey={DRAFT_KEYS.PREOPERATIVE_CHECKLIST}
                  uhidNo={uhid_no}
                  formData={formData}
                  onDraftLoaded={(draftData) => setFormData(draftData)}
                  variant="outlined"
                  size="large"
                  isUpdate={success}
                />
                <Button type="submit" variant="contained" color="primary" sx={{ marginTop: 3 }} fullWidth onClick={handleSubmit}>
                  {success === "success" ? 'Update ' : 'Submit'}
                </Button>
              </Box>
            </Grid>
          </form>
        </Paper>
      </Container>
    </ThemeProvider>
  );
};

export default PreOperativeChecklist;